import nProgress from "nprogress";
import { call, put, takeEvery } from "redux-saga/effects";
import apiService from "../../services/api/apiService";
import general from "../../utils/general";
import { ActionTypes, Actions } from "./reducers";
import i18next from "i18next";

function* BaseApiCall({ payload }) {
    if (!navigator.onLine)
        return;

    if (payload?.showLoading)
        nProgress.start();

    try {
        const apiCall = yield call(apiService.makeApiCall, {
            url: payload?.url,
            query: payload?.query,
            data: payload?.data,
            method: payload?.method,
            serviceType: payload.serviceType,
            token: payload.token,
            saveFilter: payload?.saveFilter,
            objectKeys: payload?.objectKeys,
            axiosOptions: payload?.axiosOptions,
        });

        if (apiCall?.success && payload?.onSuccess instanceof Function) {
            yield call(payload.onSuccess, { data: apiCall?.data, pagination: apiCall?.pagination });
        }

        if (apiCall?.error && payload?.onError instanceof Function) {
            yield call(payload.onError, { data: apiCall?.data, errorMessage: apiCall?.errorMessage, errorMessageTechnical: apiCall?.errorMessageTechnical });
        }

        if (payload?.callback instanceof Function) {
            yield call(payload.callback, apiCall);
        }

        if (apiCall?.error && payload?.showAlertOnError) {
            if (Array.isArray(apiCall?.errorMessage)) {
                let message = "";
                apiCall?.errorMessage.forEach(element => {
                    message += i18next.t(element.message) + "\n";
                });
                general.notificationError(message, apiCall?.useI18next);
            }
            else {
                general.notificationError(apiCall?.errorMessage, apiCall?.useI18next);
            }
        }
    } catch (error) {
        console.error("Saga error:", error);
        if (payload?.onError instanceof Function) {
            yield call(payload.onError, { errorMessage: error?.message || "Saga hatası" });
        }
    } finally {
        if (payload?.showLoading)
            nProgress.done();
    }
}

function* Get({ payload }) {
    yield put(Actions.BaseApiCall({
        ...payload,
        method: "get"
    }))
}

function* Post({ payload }) {
    yield put(Actions.BaseApiCall({
        ...payload,
        method: "post"
    }))
}

function* Put({ payload }) {
    yield put(Actions.BaseApiCall({
        ...payload,
        itemId: payload?.itemId,
        method: "put",
    }))
}

function* Delete({ payload }) {
    yield put(Actions.BaseApiCall({
        ...payload,
        method: "delete",
    }))
}

const apiCallSagas = [
    takeEvery(ActionTypes.DELETE, Delete),
    takeEvery(ActionTypes.POST, Post),
    takeEvery(ActionTypes.PUT, Put),
    takeEvery(ActionTypes.GET, Get),
    takeEvery(ActionTypes.BASE_API_CALL, BaseApiCall),
];

export default apiCallSagas;
